module.exports = {
    "wrapper": "mca5423d5d_wrapper",
    "graphWrapper": "mca5423d5d_graphWrapper",
    "graph": "mca5423d5d_graph",
    "loss": "mca5423d5d_loss",
    "legend": "mca5423d5d_legend"
};